import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AuthorizationService } from '../services/authorization.service';
import { UnauthorizedNavigationService } from '../services/unauthorized-navigation.service';
import { UserImpersonationService } from '../services/user-impersonation.service';
import { UserStore } from '../stores/user.store';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate, CanActivateChild {
  private readonly authorizationService = inject(AuthorizationService);
  private readonly unauthorizedNav = inject(UnauthorizedNavigationService);
  private readonly impersonationService = inject(UserImpersonationService);
  private readonly authService = inject(AuthService);
  private readonly userStore = inject(UserStore);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    await this.authService.waitForUsers();
    await this.userStore.loadAll();

    if (this.authorizationService.canAccessAdminFeatures()) {
      return true;
    }

    const realUserId = this.authService.currentUserId();
    const effectiveUserId = this.impersonationService.getEffectiveUserId(realUserId);

    console.warn(`Admin access denied for user ${effectiveUserId}`);
    this.unauthorizedNav.navigateToUnauthorized(route, {
      userId: effectiveUserId,
      reason: 'admin_required',
    });
    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot): Promise<boolean> {
    return this.canActivate(route);
  }
}
